export default {
  auth: {
    title: 'تسجيل الدخول',
    prompt: 'سجل الدخول إلى حسابك',
    login: 'دخول',
    password: {
      title: 'كلمة المرور',
      username: 'اسم المستخدم',
      password: 'كلمة المرور',
      forgot: 'هل نسيت بيانات الدخول؟'
    },
    card: {
      title: 'بطاقة الهوية',
      p: 'أدخل بطاقة الهوية في القارئ ثم اضغط "دخول"'
    },
    mobile: {
      title: 'الهوية عبر الهاتف',
      p1: 'رمز التحقق الخاص بك هو: {{code}}',
      p2: 'تم إرسال رسالة إلى هاتفك. تحقق من الرمز!',
      phone: 'رقم الهاتف'
    },
    smart: {
      title: 'الهوية الذكية',
      p1: 'رمز التحقق الخاص بك هو: {{code}}',
      p2: 'تم إرسال رسالة إلى هاتفك. تحقق من الرمز!',
      idCode: 'رقم الهوية'
    },
    idLogout: {
      title: 'تنبيه',
      warning: 'يرجى إعادة تشغيل المتصفح!'
    }
  }
}
